import {SuiMessageModule} from '@angular-ex/semantic-ui';
import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {Message} from '../../services/toast/message';
import {ToastService} from '../../services/toast/toast.service';

@Component({
  selector: 'app-toast-list',
  templateUrl: './toast-list.component.html',
  styleUrl: './toast-list.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SuiMessageModule],
})
export class ToastListComponent {
  messages: Message[] = inject(ToastService).messages;

  cancelHide(message: Message) {
    clearTimeout(message.timeoutId);
  }
}
